var _path, _g, _path2, _g2, _rect, _path3, _g3, _path4, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBagPersonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_263_5156",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 2,
    width: 10,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21094 2H16.2729V10.3057H7.21094V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_263_5156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5229 10.3057C15.1089 10.3057 14.7729 9.9697 14.7729 9.5557V6.52369C14.7729 4.85669 13.4179 3.49969 11.7509 3.49969C10.9399 3.52769 10.1799 3.80769 9.60594 4.37569C9.03194 4.94469 8.71394 5.70169 8.71094 6.50869V9.5557C8.71094 9.9697 8.37494 10.3057 7.96094 10.3057C7.54694 10.3057 7.21094 9.9697 7.21094 9.5557V6.52369C7.21594 5.29469 7.69094 4.16069 8.54994 3.31069C9.40794 2.45969 10.5599 2.03469 11.7539 1.99969C14.2449 1.99969 16.2729 4.0297 16.2729 6.52369V9.5557C16.2729 9.9697 15.9369 10.3057 15.5229 10.3057Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_263_5156",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 20,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.47461H21.4998V21.9996H2V6.47461Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_263_5156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00776 7.97461C5.07376 7.97461 3.49976 9.54661 3.49976 11.4796V16.9956C3.49976 18.9276 5.07376 20.4996 7.00776 20.4996H16.4918C18.4258 20.4996 19.9998 18.9276 19.9998 16.9956V11.4796C19.9998 9.54661 18.4258 7.97461 16.4918 7.97461H7.00776ZM16.4918 21.9996H7.00776C4.24676 21.9996 1.99976 19.7546 1.99976 16.9956V11.4796C1.99976 8.71961 4.24676 6.47461 7.00776 6.47461H16.4918C19.2538 6.47461 21.4998 8.71961 21.4998 11.4796V16.9956C21.4998 19.7546 19.2538 21.9996 16.4918 21.9996Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#1C8D70"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_263_5156",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 20,
    width: 6,
    height: 4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3333 20.832H21.6132V23.29H16.3333V20.832Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_263_5156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9736 21.332C17.5533 21.332 16.8333 21.576 16.8333 22.0577C16.8333 22.5437 17.5533 22.79 18.9736 22.79C20.3936 22.79 21.1133 22.546 21.1133 22.0644C21.1133 21.5784 20.3936 21.332 18.9736 21.332ZM18.9736 23.29C18.3206 23.29 16.3333 23.29 16.3333 22.0577C16.3333 20.959 17.8403 20.832 18.9736 20.832C19.6266 20.832 21.6133 20.832 21.6133 22.0644C21.6133 23.163 20.1066 23.29 18.9736 23.29Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_263_5156",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 16,
    width: 4,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2031 16.6667H20.7431V20.2062H17.2031V16.6667Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_263_5156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9735 17.1426C18.2598 17.1426 17.6791 17.7229 17.6791 18.4366C17.6768 19.1479 18.2531 19.7279 18.9638 19.7306L18.9735 19.9686V19.7306C19.6868 19.7306 20.2671 19.1499 20.2671 18.4366C20.2671 17.7229 19.6868 17.1426 18.9735 17.1426ZM18.9735 20.2062H18.9628C17.9888 20.2032 17.1998 19.4089 17.2031 18.4356C17.2031 17.4606 17.9971 16.6666 18.9735 16.6666C19.9495 16.6666 20.7431 17.4606 20.7431 18.4366C20.7431 19.4126 19.9495 20.2062 18.9735 20.2062Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagPersonIcon);
export default __webpack_public_path__ + "static/media/bag_person_icon.df7d339a4ddb2befccc9540caf29c371.svg";
export { ForwardRef as ReactComponent };